import { render, staticRenderFns } from "./default.vue?vue&type=template&id=2f584b48"
import script from "./default.vue?vue&type=script&lang=ts"
export * from "./default.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {MNavigationDrawer: require('/codebuild/output/src1415094870/src/app/components/molecules/MNavigationDrawer.vue').default,MAppBottom: require('/codebuild/output/src1415094870/src/app/components/molecules/MAppBottom.vue').default,AChangeDialog: require('/codebuild/output/src1415094870/src/app/components/atoms/Dialog/AChangeDialog.vue').default,ASnackbar: require('/codebuild/output/src1415094870/src/app/components/atoms/ASnackbar.vue').default,MAppNotification: require('/codebuild/output/src1415094870/src/app/components/molecules/MAppNotification.vue').default})
